import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import ddt from '@wix/da-ddt';
import { Url } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import type { MobileThumbProps } from '../types';
import TierPromotionCard from '../../../TierPromotionCard';
import TierPromotionCardWithFellaTooltip from '../../../TierPromotionCardWithFellaTooltip';
import { getBiDataForTierLink } from '../../../../Duperbrowse/DeviationLink/useBiDataForDeviationLink';
import { getTranslationKeyForAccessibleDeviationLink } from '../../helpers';
import s from './Tier.scss';

const TierMobileThumb: React.FC<MobileThumbProps> = ({
  deviation,
  width,
  height,
  responsive,
  className,
  style,
  showTierPromotionTooltip,
}) => {
  const { t } = useTranslation();
  const a11yLabel = getTranslationKeyForAccessibleDeviationLink(t, deviation);
  const biData = getBiDataForTierLink(deviation);

  // todo: kludge to handle width, height being in `style` too
  const {
    width: styleWidth,
    height: styleHeight,
    ...nonDimStyles
  } = style as any;
  const dimensions = responsive ? { width } : { width, height };

  // while we're here, make sure we're not somehow getting different
  // values between these two
  if (width !== styleWidth || height !== styleHeight) {
    ddt.warn('deviationviews.tiermobile', 'dimensions not matching style:', {
      deviationId: deviation.deviationId,
      showTierPromotionTooltip,
      width,
      height,
      styleWidth,
      styleHeight,
    });
  }

  return (
    <div
      style={{ ...nonDimStyles, ...dimensions }}
      className={classnames(s['root'], className)}
    >
      {showTierPromotionTooltip ? (
        <TierPromotionCardWithFellaTooltip
          deviation={deviation}
          {...dimensions}
        />
      ) : (
        <TierPromotionCard
          deviation={deviation}
          verticalLayout={responsive}
          {...dimensions}
        />
      )}
      <BiLink
        className={s['link-overlay']}
        biData={biData}
        aria-label={a11yLabel}
        href={Url.userSubscriptionsPath({
          username: deviation.author!.username,
          tierDeviationId: deviation.deviationId,
          tierContentType: 'deviations',
        })}
      >
        <span />
      </BiLink>
    </div>
  );
};
TierMobileThumb.displayName = 'TierMobileThumb';

export default TierMobileThumb;
